"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPPER_RIGHT = exports.UPPER_LEFT = exports.OverlayStyles = exports.OverlayPositions = exports.NO_POINTER_EVENTS = exports.NO_CONTENT = exports.LOWER_RIGHT = exports.LOWER_LEFT = exports.FULL_SCREEN = exports.FIT_FRAME = exports.FILL_FRAME = exports.BannerStyles = exports.BackgroundStyles = exports.BackgroundPositions = exports.BASIC_BANNER = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// positions
var UPPER_LEFT = exports.UPPER_LEFT = 'Upper left';
var UPPER_RIGHT = exports.UPPER_RIGHT = 'Upper right';
var LOWER_LEFT = exports.LOWER_LEFT = 'Lower left';
var LOWER_RIGHT = exports.LOWER_RIGHT = 'Lower right';
var FULL_SCREEN = exports.FULL_SCREEN = 'Full Screen';
var FIT_FRAME = exports.FIT_FRAME = 'Fit frame';
var FILL_FRAME = exports.FILL_FRAME = 'Fill frame';
var overlayCommonStyles = {
  height: '7.9365%',
  position: 'absolute',
  mediaStyle: {
    width: 'inherit'
  }
};
var verticalOffset = '1.0582%';
var horizontalOffset = '5.9523%';

// position styles
var OverlayStyles = exports.OverlayStyles = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, UPPER_LEFT, _objectSpread({
  top: verticalOffset,
  left: horizontalOffset
}, overlayCommonStyles)), UPPER_RIGHT, _objectSpread({
  top: verticalOffset,
  right: horizontalOffset
}, overlayCommonStyles)), LOWER_LEFT, _objectSpread({
  bottom: verticalOffset,
  left: horizontalOffset
}, overlayCommonStyles)), LOWER_RIGHT, _objectSpread({
  bottom: verticalOffset,
  right: horizontalOffset
}, overlayCommonStyles)), FULL_SCREEN, {
  bottom: '0%',
  top: '0%',
  right: '0%',
  left: '0%',
  width: '100%',
  height: '100%',
  position: 'absolute'
});
var BackgroundStyles = exports.BackgroundStyles = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, FIT_FRAME, {
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center'
}), FILL_FRAME, {
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
});
var BackgroundPositions = exports.BackgroundPositions = [FIT_FRAME, FILL_FRAME];
var OverlayPositions = exports.OverlayPositions = [UPPER_LEFT, UPPER_RIGHT, LOWER_LEFT, LOWER_RIGHT, FULL_SCREEN];
var BASIC_BANNER = exports.BASIC_BANNER = 'Basic banner';
var BannerStyles = exports.BannerStyles = (0, _defineProperty2["default"])({}, BASIC_BANNER, {
  position: 'absolute',
  bottom: '0%',
  width: '100%'
});
var NO_POINTER_EVENTS = exports.NO_POINTER_EVENTS = 'no-pointer-events';
var NO_CONTENT = exports.NO_CONTENT = 'no-content';